import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {Building} from '../model/building';
import {catchError, share} from 'rxjs/internal/operators';
import {ApiRoutes} from '../../../config/api-routes';
import {HttpClient} from '@angular/common/http';
import {ApplicationType} from '../enums/enums';
import {FloorInfo} from "../model/floor-info";

@Injectable()
export class BuildingsService {

  private buildings: Building[];
  private buildings$: Observable<Building[]>;

  constructor(private httpClient: HttpClient, private routes: ApiRoutes) {}

  public init() {
    this.buildings$ = this.getBuildingsFromServer();
    this.buildings$.subscribe(response => this.buildings = response);
  }

  public getBuildings(): Observable<Building[]> {
    return (this.buildings == null) ? this.buildings$ : of(this.buildings);
  }

  private getBuildingsFromServer(): Observable<Building[]> {
    return this.httpClient.get<Building[]>(this.routes.BUILDINGS).pipe(
      share(),
      catchError(error => {
        return of([]);
      })
    );
  }

  public getBuildingTemplateLocations(buildingId: number, application: ApplicationType): Observable<any[]> {
    return this.httpClient.get<any[]>(this.routes.BUILDING_TEMPLATE_LOCATIONS + `?buildingId=${buildingId}&application=${application}`).pipe(
      catchError(error => {
        return of([]);
      })
    );
  }
  
  public getBuildingLocations(building: Building) {
    const endpoint = this.routes.getRouteWithInjectedParams(this.routes.BUILDING_LOCATIONS, [`${building.id}`]);
    return this.httpClient.get<FloorInfo[]>(endpoint, {params: {applicationType: building.application}});
  }

  public getBuildingsOfContact(contactId: number): Observable<Building[]> {
    return this.httpClient.get<Building[]>(this.routes.getRouteWithInjectedParams(
      this.routes.BUILDINGS_BY_CONTACT, [contactId.toString()])).pipe(
      catchError(error => {
        return of([]);
      })
    );
  }
}
